import { render, staticRenderFns } from "./DaysCard.vue?vue&type=template&id=2d15c780&scoped=true&"
import script from "./DaysCard.vue?vue&type=script&lang=js&"
export * from "./DaysCard.vue?vue&type=script&lang=js&"
import style0 from "./DaysCard.vue?vue&type=style&index=0&id=2d15c780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d15c780",
  null
  
)

export default component.exports